import React from 'react';
export const HerbSprig = ({
  className = '',
  color = '#2F6B34',
  style
}: {
  className?: string;
  color?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-124" data-mp="3l3q7huw2shlh">
    <path d="M12 22v-7l-2-2" data-id="element-125" data-mp="cq9d85ejc2na" />
    <path d="M12 15l2-2" data-id="element-126" data-mp="cp84i7kzrs8q" />
    <path d="M10 13a3 3 0 0 1-3-3c0-2 2-3 2-3s1 2 1 4" data-id="element-127" data-mp="cnn6g7zgxr64" />
    <path d="M14 13a3 3 0 0 0 3-3c0-2-2-3-2-3s-1 2-1 4" data-id="element-128" data-mp="7s7x9tceojg1" />
    <path d="M12 11a3 3 0 0 1-3-3c0-2 2-3 2-3s1 2 1 4" data-id="element-129" data-mp="3p2ya0rjazw5" />
    <path d="M12 11a3 3 0 0 0 3-3c0-2-2-3-2-3s-1 2-1 4" data-id="element-130" data-mp="3ni2k7thhawp" />
  </svg>;
export const MortarPestle = ({
  className = '',
  color = '#A88838',
  style
}: {
  className?: string;
  color?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-131" data-mp="2jgh0jvak5x2x">
    <path d="M7 10l-2 10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2l-2-10" data-id="element-132" data-mp="2iukx6umoekc4" />
    <path d="M4 10h16" data-id="element-133" data-mp="24wmitp8cunwm" />
    <path d="M15 4l-4 6" data-id="element-134" data-mp="24v1q855lpf1e" />
    <path d="M17 2l-2 2" data-id="element-135" data-mp="24vtm7h341es7" />
  </svg>;
export const LeafCluster = ({
  className = '',
  color = '#6FA524',
  style
}: {
  className?: string;
  color?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-136" data-mp="1v4yxm62e633l">
    <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z" data-id="element-137" data-mp="1q6p0hpx3wsfc" />
    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" data-id="element-138" data-mp="1c6w2ran5xbxv" />
  </svg>;
export const TinctureBottle = ({
  className = '',
  color = '#C9A961',
  style
}: {
  className?: string;
  color?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-139" data-mp="3iwhipds7anq4">
    <path d="M10 2v3" data-id="element-140" data-mp="354jixtkdq46m" />
    <path d="M14 2v3" data-id="element-141" data-mp="3552salvyrk91" />
    <path d="M8 5h8v3a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5z" data-id="element-142" data-mp="355un3uhqldy9" />
    <path d="M7 10h10v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V10z" data-id="element-143" data-mp="5po8e2k1raas" />
    <path d="M12 12v6" data-id="element-144" data-mp="5n20g1t8uss1" />
    <path d="M10 15l2-2 2 2" data-id="element-145" data-mp="1nuag218kkeb" />
  </svg>;
// Aliases to keep the imports used in Hero and MethodOverview
export const FeatherQuill = HerbSprig;
export const Flame = MortarPestle;
export const MoonPhase = LeafCluster;
export const LotusBud = TinctureBottle;